module.exports = __webpack_public_path__ + "static/img/Bitmap1.6cee738.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dealer/Bitmap1.png
// module id = RCGY
// module chunks = 1